var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_38336",
    "data-name": "Group 38336",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.067,
    height: 32.526,
    viewBox: "0 0 35.067 32.526",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_11",
    "data-name": "Polygon 11",
    d: "M26.3,0l8.767,16.263L26.3,32.526H8.767L0,16.263,8.767,0Z",
    transform: "translate(0 0)",
    fill: "#60c6a7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_create_task_1863713",
    "data-name": "noun_create task_1863713",
    transform: "translate(10.659 8.732)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65385",
    "data-name": "Path 65385",
    d: "M7.152,4.514V3.676H8.728A1.628,1.628,0,0,1,10.3,2,1.628,1.628,0,0,1,11.88,3.676h1.576v.838a.814.814,0,0,1-.788.838H7.94A.814.814,0,0,1,7.152,4.514Zm4.824,9.812a.765.765,0,0,1-.557.245H10.3a.814.814,0,0,1-.788-.838V12.549a.866.866,0,0,1,.231-.593l5.9-6.274a1.537,1.537,0,0,1,.778-.45,2.4,2.4,0,0,0-1.785-1.514v.8a2.036,2.036,0,0,1-1.97,2.1H7.94a2.036,2.036,0,0,1-1.97-2.1v-.8A2.47,2.47,0,0,0,4,6.191v8.381a2.443,2.443,0,0,0,2.364,2.514h7.88a2.443,2.443,0,0,0,2.364-2.514V9.4Zm3.833-5.262L14.694,7.879,10.3,12.548v1.185h1.114Zm1.508-2.79a.756.756,0,0,0-1.114,0l-.659.7,1.114,1.185.659-.7a.877.877,0,0,0,0-1.185Z",
    transform: "translate(-4 -2)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignmentIcon);
export default __webpack_public_path__ + "static/media/assignmentIcon.0b419cd1d8c48d42023b8ff4accdcba0.svg";
export { ForwardRef as ReactComponent };